<template>
    <table class="t" v-if="headers.length">
        <thead class="t-head">
            <tr class="t-row">
                <th scope="col" v-for="header in headers" :key="header.key">
                    {{ header.label }}
                </th>
                <th scope="col">
                    Actions
                </th>
            </tr>
        </thead>
        <tbody class="t-body">
            <tr v-if="!elements.length">
                <slot name="no-items">{{ noItems }}</slot>
            </tr>
            <template v-else>
                <tr
                    v-for="(item, index) in items"
                    class="t-row"
                    :key="'item-' + index"
                >
                    <td
                        v-for="(attr, jIndex) in headers"
                        :key="'td' + item[attr.key] + jIndex"
                    >
                        {{ item[attr.key] }}
                    </td>

                    <td>
                        <slot name="actions" :item="item">
                            NA
                        </slot>
                    </td>
                </tr>
            </template>
        </tbody>
    </table>
</template>

<script>
import _ from 'lodash';
import { watchEffect } from 'vue';
export default {
    props: {
        items: {
            type: Array,
        },
        fields: {
            type: Array,
        },
        noItems: {
            type: String,
            default: 'No hay elementos',
        },
    },
    computed: {
        elements() {
            return this.items;
        },
        headers() {
            const attributes = {};
            for (const item of this.items) {
                for (const attr in item) {
                    _.set(attributes, attr, '');
                }
            }

            const headers = [...Object.keys(attributes)].map(elem => {
                return {
                    label:
                        elem.charAt(0).toUpperCase() +
                        elem.slice(1).replace('_', ' '),
                    key: elem,
                };
            });

            return headers;
        },
    },
};
</script>

<style lang="scss" scoped>
.t {
    width: 100%;
    margin: 10px 0;
    border: 1px solid black;
    overflow-x: auto;
    &-head {
        background-color: black;
        color: white;
    }
    &-body {
        .t-row {
            text-shadow: 1px 1px 5px black;
            &:nth-child(even) {
                background-color: #caf0f8;
            }
            &:nth-child(odd) {
                background-color: #90e0ef;
            }

            &:hover {
                background-color: #0096c7;
                color: white;
                cursor: pointer;
            }
        }
    }
}

button {
    padding: 5px;
    margin: 3px;
}
</style>
